import { Component, HostBinding, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cc-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss']
})
export class ContainerComponent implements OnInit {
  @HostBinding('class.cc-container') containerClass;
  @Input() fullWidth: boolean;
  constructor() {}

  ngOnInit() {
    this.containerClass = !this.fullWidth;
  }
}
